<div class="cpcontent">
    <h2>GPS Logs</h2>


    <div class="row">
        <div class="col-md-5">
            <table class="table table-bordered">
                <thead>
                    <tr>

                        <th>Scenario</th>
                        <th>Downlod</th>
                        <th>Organization<i class="bi bi-arrow-down-up"  style="font-size: 1.5em;" (click)="sortGeneric(overview,'organizationname',sortArray)"></i></th>
                        <th>Count</th>
                        <th>Last Date<i class="bi bi-arrow-down-up"  style="font-size: 1.5em;" (click)="sortGeneric(overview,'lastDate',sortArray)"></i></th>
                        <th>Delete</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let b of overview">

                        <td class="link" (click)="selectByScnearioId(b)">{{b.scenarioname}}</td>

                        <td class="link" ><i class="bi bi-download"  style="font-size: 1.5em;" (click)="downloadScenario(b.id)"></i></td>
                        <td>{{b.organizationname}}</td>
                        <td>{{b.count}}</td>
                        <td>{{b.lastDate | date: 'shortDate'}}</td>
                        <td class="link" (click)="deleteAllScenario(b)">Delete</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="col-md-7">
            <div *ngIf="showPhonInfos" style="display:inline-block">
                <h5>{{selectedScenario.scenarioname}}, {{selectedScenario.organizationname}}</h5>
            </div>
            <button style="float:right" class="btn btn-primary btn-sm;" (click)="deleteSelected()">Delete Selected</button>
            <table *ngIf="showPhonInfos" class="table table-bordered">
                <thead>
                    <tr>
                        <th>Phone Session</th>
                        <th>Count</th>
                        <th>First Date</th>
                        <th>Delete</th>
                        <th>Select</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let b of scenariooverview">
                        <td class="link" (click)="selectByPhoneInfo(b)">{{b.name}}</td>
                        <td>{{b.count}}</td>
                        <td>{{b.firstRecord.dateCreated | date: 'shortDate'}}</td>
                        <td class="link" (click)="deleteAllPhoneInfo(b)">Delete</td>
                        <td><sa-input-boolean [(checked)]="b.selected" [title]="''" [required]="'none'"></sa-input-boolean></td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <!---- Now comes the GPS map --------------------------------------------------->
    <div *ngIf="showmapheader" style="display:inline-block;margin-right:20px">
        <h5>{{selectedScenario.scenarioname}}, {{selectedScenario.organizationname}} with phoneinfo {{phoneinfo}}</h5>
    </div>
    <button class="btn btn-primary btn-sm" (click)="showWalk()">Show Walk</button>
    <sa-input-number style="display:inline-block;max-width:150px;margin-left:10px" [(text)]="walkInterval" [title]="'Interval [ms]'" [required]="'none'"></sa-input-number>
    <sa-input-boolean style="display:inline-block;max-width:150px;margin-left:10px" [(checked)]="showAccuracy" [title]="'Show Accuracy'" [required]="'none'"></sa-input-boolean>
    <div #pagemap style="width:100%;height:900px"></div>
    <br>
    <table *ngIf="showRecords" class="table table-bordered">
        <thead>
            <tr>
                <th>Id</th>
                <th>Date Time</th>
                <th>Long Lat</th>
                <th>Accuracy</th>
                <th>Phone Info</th>
                <th>Organization</th>
                <th>Height</th>
            </tr>
        </thead>
        <tbody>
            <tr *ngFor="let b of gpslogs">
                <td>{{b.id}}</td>
                <td>{{b.dateCreated | date: 'YYYY MM dd : HH mm ss'}}</td>
                <td>{{b.longitude}} / {{b.latitude}}</td>
                <td>{{b.accuracy}}</td>
                <td>{{b.phoneInfo}}</td>
                <td>{{lookup(b.organizationId,organizations)}}</td>
                <td>{{b.height}}</td>
            </tr>
        </tbody>
    </table>
</div>